import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, AfterViewInit, OnDestroy } from '@angular/core';
import * as momentNs from 'moment';
import { registerLocaleData } from '@angular/common';
import es from '@angular/common/locales/es';
import { InvestPopupHeaderComponent } from './invest-popup-header/invest-popup-header.component';
import { TranslateService } from '@ngx-translate/core';
import { OverviewProjectService } from 'src/app/services/overview-project.service';
import { ActionSheetService } from '../action-sheet/action-sheet.service';
import { ToastService } from '../toast/toast.service';
import { HelpService } from 'src/app/services/help.service';
import { HubspotService } from 'src/app/services/hubspot.service';
import { Storage } from '@ionic/storage';
import { UtilsService } from 'src/app/services/utils.service';
import { PosthogService } from 'src/app/services/posthog.service';
import { MangopayScaValidationComponent } from '../mangopay-sca-validation/mangopay-sca-validation.component';
import { AlertService } from '../alert/alert.service';
import { OveralMessageComponent } from '../overal-message/overal-message.component';
import { DataLayerService } from 'src/app/services/data-layer.service';
import { ProfileService } from 'src/app/services/profile.service';

const moment = momentNs;

@Component({
  selector: 'app-invest',
  templateUrl: './invest.component.html',
  styleUrls: ['./invest.component.scss'],
})
export class InvestComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output() public investEvent = new EventEmitter<any>();
  @Output() public investByWalletEvent = new EventEmitter<any>();
  @Output() public newInvestEvent = new EventEmitter<any>();
  @Output() public goToHomeEvent = new EventEmitter<any>();
  @Output() public shareTestEvent = new EventEmitter<any>();
  @Output() public keepOpenEvent = new EventEmitter<any>();
  @Output() public notKeepopenEvent = new EventEmitter<any>();
  @Output() public investmentQueueEvent = new EventEmitter<any>();
  @Output() public getPayTypeEvent = new EventEmitter<any>();
  @Output() public getCodePromotionEvent = new EventEmitter<any>();
  @Output() public startSignEvent = new EventEmitter<any>();
  @Output() public confirmInvestWalletEvent = new EventEmitter<any>();
  @Output() public finishSignOneDocumentEvent = new EventEmitter<any>();
  @Output() public signaturitIssueEvent = new EventEmitter<any>();
  @Output() public amountValueEvent = new EventEmitter<any>();
  @Output() public purchaseEvent = new EventEmitter<any>();
  @Output() public cancelInvestEvent = new EventEmitter<any>();
  @Output() public localInvestIdEvent = new EventEmitter<any>();
  @Output() public closeAndCheckIbanEvent = new EventEmitter<any>();
  @Output() public stepsEvent = new EventEmitter<any>();
  @Output() public dontChangeHubspotStageEvent = new EventEmitter<any>();
  @Input() data: any;
  @Input() test: any;
  @Input() amount: any;
  @Input() localInvestProject: any;
  @Input() profile: any;
  @Input() canChangeStage: boolean = true;

  headerData: any;
  bodyData: any;
  daysLeft: any;
  step = 0;
  testInfo: any;
  invest: number;
  countDown: any;
  lwUrl: any;
  investByCard: boolean;
  transaction: any;
  signaturitTransId: any;
  errors = [];
  loaderInvestProcess: boolean;
  shareText: any;
  isTimeStop = false;
  lessThanMinuts: boolean;

  hasPrevInvest: boolean;
  moneyInvested: any;
  moneyExpected: any;
  percentInv: any;
  leftInv: any;
  isDocumentSigned = false;
  paymentType: string;

  countdownStarted = false;
  localInvestId: any;

  promotionalModel: any;
  interval: any;

  investId: any;
  previewDocuments;
  hubspotQuestion = false;

  deal: any;

  totalOfficialPercent: number;
  minExceeded: boolean = false;

  private timeoutId: any;
  lastPosthogEvent: string;
  barData: any;
  lastInvestData: any;

  hasToBookInvestment: boolean = false;
  userValidatedInPriorityGroup: boolean = false;
  bookText: string;
  showOverfundedWarning: boolean = false;
  originalStep: number = 0;
  btnBookList: any;

  // Priority group investment logic
  userPriorityGroup: any = null;
  userHasGroupWithObjective: boolean = false;
  userGroupMaxInvestment: number = 0;
  showGroupsTable: boolean = false;
  groupsInvestmentData: any[] = [];
  globalUsersInvestment: number = 0;
  maxFromLessPriorityGroups: number = 0;
  showPriorityWarning: boolean = false;
  shouldShowReservation: boolean = false;
  priorityNumber: number;
  totalsPercent: number = 0;
  advisePercentShowed: boolean = false;

  isPreorderStage = false;

  constructor(
    public actionSheetService: ActionSheetService,
    private cdRef: ChangeDetectorRef,
    private toastService: ToastService,
    private translate: TranslateService,
    private helpService: HelpService,
    private overviewService: OverviewProjectService,
    private posthogService: PosthogService,
    private HubspotService: HubspotService,
    private storage: Storage,
    private overviewProjectService: OverviewProjectService,
    private utilsService: UtilsService,
    private alertService: AlertService,
    private dataLayerService: DataLayerService,
    private profileService: ProfileService
  ) { }

  ngOnInit() {
    const contributed = this.data.bodyInfo.contributed + this.data.headerInfo.reserved;
    const preordered = this.data.headerInfo.preordered || 0;
    const objectiveOfficial = this.data.headerInfo.objective_official || 0;
    if (objectiveOfficial > 0 && (contributed + preordered) > objectiveOfficial) {
      this.minExceeded = true;
    }
    this.barData = {
      contributed,
      id: this.data.bodyInfo.id,
      status: this.data.bodyInfo.status,
      reserved: preordered,
      total: this.data.bodyInfo.total,
      total_official: objectiveOfficial,
      min_exceeded: this.minExceeded
    };
    this.deal = this.data.projectDeal;
    this.previewDocuments = this.data.signDocuments !== undefined && this.data.signDocuments.length > 0 ? true : false;
    this.data.bodyInfo.projectName = this.data.headerInfo.name;
    this.loaderInvestProcess = false;
    this.countDown = '30:00';
    if (((this.test && this.test !== undefined) || (this.profile.dontRequestInvestmentExperienceInfo !== true && this.profile.isExperiencedInvestor === null)) && this.data.headerInfo.status !== 15) {
      this.step = 0;
    } else {
      this.step = 1;
    }

    // Priority group investment logic
    this.calculatePriorityGroupLogic();
    registerLocaleData(es);
    this.headerData = this.data.headerInfo;
    this.testInfo = this.test;
    this.bodyData = this.data.bodyInfo;
    this.getDaysLeft();

    if (this.headerData.invested && this.headerData.invested !== undefined) {
      this.hasPrevInvest = true;
      this.getPrevInvest(this.headerData.invested);
    } else {
      this.hasPrevInvest = false;
    }

    if (this.headerData.objective_official && this.headerData.objective_official > 0) {
      this.totalOfficialPercent = (this.headerData.objective_official * 100) / this.headerData.objective;
    }

    this.checkCurrentDeal();
    this.cdRef.detectChanges();
  }

  timer(defatulStage?, specificParams?) {
    if (defatulStage !== undefined) {
      this.timeoutId = setTimeout(() => {
        this.checkCurrentDeal(defatulStage, specificParams);
      }, 100);
    } else {
      this.timeoutId = setTimeout(() => {
        this.checkCurrentDeal();
      }, 4000);
    }
  }

  checkCurrentDeal(defatulStage?, specificParams?) {
    this.storage.get('USERNAME').then((val) => {
      const userEmail = val;
      const idProject = this.data.investInfo.id;
      if (this.deal === undefined) {
        this.HubspotService.getDeals(userEmail, idProject).subscribe((resHusbpot: any) => {
          if (resHusbpot.success) {
            const deals = resHusbpot.data.results;
            if (deals.length) {
              this.deal = deals[0];
              if (defatulStage !== undefined) {
                this.changeHuspotStage(defatulStage, specificParams);
              } else {
                this.changeHuspotStage();
              }
            } else {
              if (defatulStage !== undefined) {
                this.timer(defatulStage, specificParams);
              } else {
                this.timer();
              }
            }
          }
        });
      } else {
        this.changeHuspotStage();
      }
    });
  }

  changeHuspotStage(defatulStage?, specificParams?) {
    let stage = '';
    let params = {};
    let sum = 0;
    let promotionalMoney;
    let sumParse;
    if (this.promotionalModel && this.promotionalModel['promos']) {
      for (let i = 0; i < this.promotionalModel['promos'].length; i++) {
        sum += this.promotionalModel['promos'][i].netAmount;
      }
      sumParse = Number(sum.toFixed(2)); // Corrige error decimal de js
    } else {
      sumParse = 0;
    }
    promotionalMoney = Math.floor(sumParse);
    const amountInvest = this.promotionalModel && this.promotionalModel.add ? this.amount + promotionalMoney : this.amount;
    if (defatulStage === undefined) {
      switch (this.step) {
        case 0:
          this.stepsEvent.emit({ 'title': 'Inversión', 'step': 1, 'total': 3 });
          stage = 'test';
          break;
        case 1:
          if (this.headerData.status !== 15) {
            this.stepsEvent.emit({ 'title': 'Pago', 'step': 1, 'total': 3 });
            stage = 'checkout';
          }
          break;
        case 2:
          if (this.investByCard) {
            this.stepsEvent.emit({ 'title': 'Pago', 'step': 1, 'total': 3 });
            stage = 'payment';
          } else {
            this.stepsEvent.emit({ 'title': 'Documentación y firma', 'step': 2, 'total': 3 });
            stage = 'sign';
          }
          params = { amount: amountInvest };
          break;
        case 3:
          this.stepsEvent.emit({ 'title': 'Documentación y firma', 'step': 2, 'total': 3 });
          stage = 'sign';
          params = { amount: amountInvest };
          break;
        case 4:
          this.stepsEvent.emit({ 'title': 'Confirmación', 'step': 3, 'total': 3 });
          stage = 'ok';
          break;
        case 5:
          this.stepsEvent.emit({ 'title': 'Confirmación', 'step': 3, 'total': 3 });
          stage = 'preinvestment';
          break;
      }
    } else {
      stage = defatulStage;
    }

    if (stage !== '' && stage !== undefined) {
      let trackParams = {
        project_status: this.headerData.status,
        project_id: this.data.bodyInfo.id,
        project_name: this.data.bodyInfo.projectName,
        amount: amountInvest
      };
      if (this.lastPosthogEvent !== `invest_${stage}`) {
        this.lastPosthogEvent = `invest_${stage}`;
        if (stage === 'ok') {
          trackParams['invest_id'] = this.investId;
        }
        this.posthogService.pushEventParams(`invest_${stage}`, trackParams);
      }
      params['estado_del_proyecto'] = this.headerData.status;
      if (stage === 'ok') {
        this.HubspotService.updateDeal(this.deal.id, stage, { amount: (this.moneyInvested + amountInvest) }).subscribe((resHusbpot: any) => {
          this.deal = resHusbpot.data;
          this.storage.get('HS_PRODUCT_ID').then(val => {
            this.HubspotService.createOrder(val, amountInvest).subscribe((resHusbpot: any) => {
              if (resHusbpot.success) {
                const order = resHusbpot.data;
                if (order) {
                  const deal = this.deal.id;
                  this.HubspotService.associateDealOrder(deal, order.id).subscribe((resHusbpot: any) => { });
                  this.canChangeStage = false;
                  this.dontChangeHubspotStageEvent.emit();
                  this.cdRef.detectChanges();
                }
              }
            });
          })
        });
      } else if (stage === 'reservation' || stage === 'preinvestment' || stage === 'investmentIntention') {
        const money = specificParams && specificParams.amount ? specificParams.amount : this.amount;
        const priorityN = this.priorityNumber ? this.priorityNumber : '';
        this.HubspotService.updateDeal(this.deal.id, stage, { amount: (money), grupo_prioritario: priorityN }).subscribe((resHusbpot: any) => {
          this.deal = resHusbpot.data;
          if (stage === 'reservation' || stage === 'preinvestment') {
            this.canChangeStage = false;
            this.dontChangeHubspotStageEvent.emit();
          }
          this.cdRef.detectChanges();
        });
      } else if (this.deal.properties.dealstage !== this.HubspotService.getStage('ok') && this.canChangeStage) {
        this.HubspotService.updateDeal(this.deal.id, stage, params).subscribe((resHusbpot: any) => {
          this.deal = resHusbpot.data;
        });
      }
    }
    this.cdRef.detectChanges();
  }

  ngAfterViewInit() {
    this.cdRef.detectChanges();
  }

  updateHubsportReservation(model) {
    this.changeHuspotStage('reservation', model);
  }

  getPrevInvest(prev) {
    const invested = [];
    const moneyExpected = [];
    prev.forEach(element => {
      invested.push(element.invested);
      moneyExpected.push(element.totalRevenue);
    });
    this.moneyInvested = invested.reduce((a, b) => a + b, 0);
    this.moneyExpected = moneyExpected.reduce((a, b) => a + b, 0);
    this.percentInv = (this.moneyInvested / this.headerData.objective) * 100 + '%';
    this.leftInv = ((((this.headerData.contributed / this.headerData.objective) * 100))
      - ((this.moneyInvested / this.headerData.objective) * 100)) + '%';
  }

  getMoneyToInvest(event) {
    this.invest = event.invest;
    this.amount = event.invest;
    this.data.moneyInvested = this.invest;
    this.investProcess(event);
    this.cdRef.detectChanges();
  }

  validateSca(event) {
    const params = this.utilsService.getMangopayValidationParams(this.profile);
    this.alertService.showModal(MangopayScaValidationComponent, params, '', '', true).subscribe((modal: any) => {
      modal.getChildComponent().subscribe((componentRef: MangopayScaValidationComponent) => {
        componentRef.finishEvent.subscribe(val => {
          this.alertService.removeModal();
          this.profile.mpUserCategory = 1;
          this.profile.isMangopayScaContactInformationUpdateConsent = true;
          this.profile.isMangopayScaRecipientRegistrationConsent = true;
          this.profile.isMangopayScaTransferConsent = true;
          this.profile.isMangopayScaViewAccountInformationConsent = true;
          this.investProcess(event);
          this.cdRef.detectChanges();
        });
      });
      modal.onClose().subscribe();
      modal.activeCross().subscribe();
    });
  }

  investProcess(event) {
    this.lastInvestData = event;
    this.dataLayerService.pushEcomEventGTM('begin_checkout', {
      'currency': 'EUR',
      'items': [{
        'item_id': this.data.investInfo.id,
        'item_name': this.data.headerInfo.name,
        'price': event.amount,
        'quantity': 1
      }]
    });
    if (this.utilsService.getMangopayValidationParams(this.profile)) {
      this.validateSca(event);
      this.cdRef.detectChanges();
    } else {
      this.investByCard = event.mode === 1 ? true : false;
      this.data.investByCard = this.investByCard;
      const idP = this.data.investInfo.id;
      const modelP = {
        accept_conditions: true,
        amount: event.invest.toString().replace(',', '.'),
        promotional_code: event.code,
        wallet: this.data.investInfo.wallet,
        username: this.data.investInfo.username,
        invest_by_card: this.investByCard,
        mangopay_user_id: this.data.bodyInfo.mangopayUserId,
        investment_stage_id: event.investmentStageId,
        priority_group_id: event.projectPriorityGroupId
      };
      if (this.investByCard) {
        modelP['invest_by_card_in_mangopay'] = true;
      }
      if (this.localInvestId !== undefined) {
        modelP['project_participations_id'] = this.localInvestId;
      }
      if (this.promotionalModel.add && this.promotionalModel.promos.length > 0) {
        modelP['promotional_movements'] = this.promotionalModel.promos;
        let sum = 0;
        for (let i = 0; i < this.promotionalModel.promos.length; i++) {
          sum += this.promotionalModel.promos[i].netAmount;
        }
        const sumParse = sum !== 0 ? Number(sum.toFixed(2)) : 0;
        modelP.amount = (Number(modelP.amount) + Math.floor(sumParse)).toString();
        this.invest = modelP.amount;
      }
      const params = {
        id: idP,
        model: modelP
      };
      this.loaderInvestProcess = true;
      if (this.data.bodyInfo.reserved_list.length > 0) {
        for (let i = 0; i < this.data.bodyInfo.reserved_list.length; i++) {
          this.overviewService.getCancelInvest(this.data.bodyInfo.reserved_list[i].id).subscribe(() => {
            if (i + 1 === this.data.bodyInfo.reserved_list.length) {
              this.investEvent.emit(params);
              this.data.bodyInfo.reserved_list = [];
              this.cdRef.detectChanges();
            }
          }, error => {
            if (i + 1 === this.data.bodyInfo.reserved_list.length) {
              this.investEvent.emit(params);
              this.data.bodyInfo.reserved_list = [];
              this.cdRef.detectChanges();
            }
          });
        }
      } else {
        this.investEvent.emit(params);
        this.data.bodyInfo.reserved_list = [];
        this.cdRef.detectChanges();
      }
      if (event.amount >= 24000 && this.data.investInfo.id === 161) {
        const body = `Inversión superior a 24K€`;
        const subject = `${this.profile.username} ha realizado una inversión de ${event.amount} que debe ser revisada por Statkraft`;
        this.HubspotService.createTask(subject, body).subscribe(() => { });
      }
      this.changeHuspotStage();
      this.cdRef.detectChanges();
    }

  }

  public getInvestResponse(resp) {
    if (this.hasToBookInvestment) {
      this.step = 5;
      this.bookText = this.userValidatedInPriorityGroup ? '<h2>Reserva realizada</h2><p>Tu reserva fija posición en la cola, pero no garantiza el hueco. Puede ser desplazada por inversores con mayor prioridad durante la ventana de consolidación de 24 horas. Las reservas no se pueden modificar. Si cancelas para cambiar el importe, pierdes tu posición.</p>' : '<h2>Reserva realizada</h2><p>Tu reserva fija posición en la cola, pero no garantiza el hueco. Puede ser desplazada por inversores con mayor prioridad durante la ventana de consolidación de 24 horas. Las reservas no se pueden modificar. Si cancelas para cambiar el importe, pierdes tu posición.</p>';
      this.btnBookList = [
        {
          type: 'primaryDark',
          index: 1,
          title: 'Continuar',
        }
      ];
      this.loaderInvestProcess = false;
      this.changeHuspotStage();
    } else {
      this.countdown();
      this.transaction = resp.response.transaction;
      if (this.investByCard) {
        // window.open(this.transaction.lleidanet);
        this.step = 2;
        this.changeHuspotStage();
        this.keepOpenEvent.emit();
      } else {
        this.finishInvest();
        this.changeHuspotStage();
      }
    }
    this.cdRef.detectChanges();
  }

  public getErrors(errors) {
    let txtError = '';
    errors.forEach(element => {
      if (element === 113) {
        this.amount = '';
        if ((this.amount + this.headerData.contributed) > this.headerData.total) {
          this.translate.get('invest.errors.' + element).subscribe(x => {
            txtError = txtError.concat(x);
            txtError = txtError.concat(' ');
          });
        } else {
          this.investmentQueueEvent.emit();
        }
      } if (element === 103 && this.profile.walletstatus === -1) { // this.profile.mpUserCategory === 0
        const modalParams = {
          image: 5,
          //profileType
          text: this.translate.instant('INVEST.MANGOPAY_VALIDATION'),
          btnList: [
            {
              type: 'primaryDark',
              index: 1,
              title: 'Intentar de nuevo',
            },
          ],
        };
        this.alertService.showModal(OveralMessageComponent, modalParams, '', '', true).subscribe((modal: any) => {
          modal.getChildComponent().subscribe((componentRef: OveralMessageComponent) => {
            componentRef.btnEvent.subscribe(() => {
              this.alertService.removeModal();
              this.investProcess(this.lastInvestData);
              this.cdRef.detectChanges();
            });
          });
          modal.onClose().subscribe();
          modal.activeCross().subscribe();
          this.cdRef.detectChanges();
        });
      } else if (element === 134) {
        const modalParams = {
          image: 5,
          text: this.translate.instant('invest.errors.reserve_exceded'),
          btnList: [
            {
              type: 'primaryDark',
              index: 1,
              title: this.translate.instant('NEWS.CTA'),
            },
            {
              type: 'ghost',
              index: 2,
              title: this.translate.instant('BIOMETRIC.CANCEL'),
            },
          ],
        };
        this.alertService.showModal(OveralMessageComponent, modalParams, '', '', true).subscribe((modal: any) => {
          modal.getChildComponent().subscribe((componentRef: OveralMessageComponent) => {
            componentRef.btnEvent.subscribe((val) => {
              this.alertService.removeModal();
              if (val === 1) {
                this.changeHuspotStage('investmentIntention', { amount: this.amount });
              }
              this.cdRef.detectChanges();
            });
          });
          modal.onClose().subscribe();
          modal.activeCross().subscribe();
          this.cdRef.detectChanges();
        });
      } else {
        this.translate.get('invest.errors.' + element).subscribe(x => {
          txtError = txtError.concat(x);
          txtError = txtError.concat(' ');
        });
      }
    });
    if (txtError !== '') {
      this.toastService.showToast(txtError, 'warning', true);
    }
    this.localInvestProject = false;
    this.loaderInvestProcess = false;
    this.errors = errors;
    const params = {
      msg: txtError,
      amount: this.amount
    }
    this.cdRef.detectChanges();
  }

  finishInvest() {
    const model = {
      investId: this.transaction.id,
      projectId: this.data.bodyInfo.id
    }

    if (this.investByCard) {
      this.overviewProjectService.createSign(model).subscribe(resp => {
        if (resp.transaction && (resp.transaction.lleidanet || resp.transaction.signaturit)) {
          this.transaction['signaturit'] = resp.transaction['signaturit'] || null;
          this.transaction['lleidanet'] = resp.transaction['lleidanet'] || null;
          this.transaction['lleidanetID'] = resp.transaction['lleidanetID'] || null;
          this.paymentType = 'Card';
          this.step = 3;
          this.loaderInvestProcess = false;
          this.changeHuspotStage();
          // this.keepOpenEvent.emit();
        } else {
          this.investByWallet();
        }
        this.cdRef.detectChanges();
      }, error => {
        if (error.error.errors && error.error.errors.length > 0) {
          this.utilsService.showErrors(error.error.errors);
        }
      });
      this.cdRef.detectChanges();
    } else {
      this.overviewProjectService.createSign(model).subscribe(resp => {
        if (resp.transaction && (resp.transaction.lleidanet || resp.transaction.signaturit)) {
          this.step = 2;
          this.transaction['signaturit'] = resp.transaction['signaturit'] || null;
          this.transaction['lleidanet'] = resp.transaction['lleidanet'] || null;
          this.transaction['lleidanetID'] = resp.transaction['lleidanetID'] || null;
          this.loaderInvestProcess = false;
          //this.keepOpenEvent.emit();
          this.changeHuspotStage();
        } else {
          this.investByWallet();
        }
        this.cdRef.detectChanges();
      }, error => {
        if (error.error.errors && error.error.errors.length > 0) {
          this.utilsService.showErrors(error.error.errors);
        }
      });
      this.paymentType = 'Wallet';
    }
    this.cdRef.detectChanges();
  }

  lleidanetSignOk() {
    this.investByWallet();
    this.cdRef.detectChanges();
  }

  investByWallet() {
    this.notKeepopenEvent.emit();
    this.investByWalletEvent.emit(this.transaction);
    // this.loaderInvestProcess = false;
    this.changeHuspotStage();
    this.cdRef.detectChanges();
  }

  signaturitIssue() {
    this.signaturitIssueEvent.emit();
  }

  public confirmInvest(event) {
    if (event === false) {
      // Ha habido un problema a la hora de invertir
      this.loaderInvestProcess = false;
      this.localInvestProject = false;
      this.step = 1;
      this.changeHuspotStage();
      const errorMsg = this.translate.instant('FORMALITIES.ERROR_INVEST_PROCESS');
      this.toastService.showToast(errorMsg, 'warning', true);
      const params = {
        msg: this.translate.instant('FORMALITIES.ERROR_INVEST_PROCESS'),
        amount: this.amount
      }
    } else {
      this.isTimeStop = true;
      // if (this.transaction.amount >= 2000 && this.data.bodyInfo.isFirstInvestment) {
      //   this.hubspotQuestion = true;
      // }
      this.step = 4;
      this.dataLayerService.pushEcomEventGTM('purchase', {
        'transaction_id': this.investId,
        'affiliation': 'Web',
        'value': this.amount,
        'currency': 'EUR',
        'coupon': this.data.promCode,
        'payment_type': this.paymentType,
        'items': [{
          'item_id': this.data.investInfo.id,
          'item_name': this.data.headerInfo.name,
          'price': this.amount,
          'item_brand': this.data.spanInfo.company,
          'item_category': this.data.spanInfo.technologyText,
          'item_list_name': 'En Financiación',
          'item_location': this.data.spanInfo.location,
          'item_profit': this.data.headerInfo.profitability + '%',
          'item_goal': this.data.headerInfo.objective,
          'quantity': 1
        }]
      });
      this.changeHuspotStage();
      this.notKeepopenEvent.emit();
      this.confirmInvestWalletEvent.emit(this.transaction);
    }
    this.cdRef.detectChanges();
  }

  successInvestedCard() {
    this.isTimeStop = true;
    // if (this.transaction.amount >= 2000 && this.data.bodyInfo.isFirstInvestment) {
    //   this.hubspotQuestion = true;
    // }
    this.step = 3;
    this.notKeepopenEvent.emit();
    const params = {
      msg: 'Inversion realizada',
      amount: this.amount,
      method: 'card'
    }
    this.changeHuspotStage();
    this.cdRef.detectChanges();
  }

  share() {
    this.shareText = 'http://twitter.com/intent/tweet?text=https://www.fundeen.com/es/invertir-energia-solar?id=' +
      this.data.investInfo.id + ' ' + this.translate.instant('invest.social_text');
    window.open(this.shareText);
    this.cdRef.detectChanges();
  }

  goHome() {
    this.goToHomeEvent.emit();
  }

  testSucess(event) {
    this.step = 1;
    try {
      this.changeHuspotStage();
    } catch {
      console.log('error')
    }
    this.cdRef.detectChanges();
  }

  getDaysLeft() {
    let endDateN;
    let todayN;
    endDateN = new Date(this.convertToIos(moment(this.headerData.end_date).format('YYYY-MM-DD') + ' 00:00:00')).getTime();
    todayN = new Date(this.convertToIos(moment().format('YYYY-MM-DD') + ' 00:00:00')).getTime();
    if (endDateN === isNaN || endDateN === undefined || !endDateN) {
      // method for firefox
      endDateN = new Date(this.convertToIos(moment(this.headerData.end_date.replace('/', '-')
        .replace('/', '-')).format('YYYY-MM-DD') + ' 00:00:00')).getTime();
    }
    this.daysLeft = (endDateN - todayN) / (1000 * 60 * 60 * 24);
  }

  closeModal() {
    this.goToHomeEvent.emit();
    this.cdRef.detectChanges();
  }

  showInfo() {
    if (this.step === 1) {
      const modalParams = {
        data: this.headerData
      };
      this.actionSheetService.showModal(InvestPopupHeaderComponent, modalParams, '', '', true).subscribe(
        (modal: any) => {
          //modal.setTitle('Invertir');
          modal.setSide('top');
          modal.onClose().subscribe();
        }
      );
    }
  }

  convertToIos(date) {
    const arr = date.split(/[- :]/);
    const r = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
    return r;
  }

  newInvest() {
    this.newInvestEvent.emit();
    this.cdRef.detectChanges();
  }

  testFail() {
    const toastText: any = this.translate.instant('invest.fail_test');
    this.toastService.showToast(toastText, 'warning', true);
  }

  signError() {
    this.localInvestProject = false;
    this.step = 1;
    this.loaderInvestProcess = false;
    this.toastService.showToast(this.translate.instant('FORMALITIES.SIGNATURE_ERROR'), 'warning', true);
    this.changeHuspotStage();
    this.cdRef.detectChanges();
  }

  stopTime() {
    this.isTimeStop = true;
    this.notKeepopenEvent.emit();
    this.cdRef.detectChanges();
  }

  deleteHeader(value) {
    this.isTimeStop = value;
    this.cdRef.detectChanges();
  }

  countdown() {
    if (!this.countdownStarted) {
      let seconds = 1800;
      this.countdownStarted = true;
      this.interval = setInterval(() => {
        const minutes = Math.round((seconds - 30) / 60);
        const remainingSeconds = seconds % 60;
        let secondsToEnd: any;
        let minutesRemaining: any;
        if (remainingSeconds < 10) {
          secondsToEnd = '0' + remainingSeconds;
        } else {
          secondsToEnd = remainingSeconds;
        }
        if (minutes < 10) {
          minutesRemaining = '0' + minutes;
          if (minutes >= 1) {
            minutesRemaining = '0' + minutes;
          } else {
            minutesRemaining = '';
          }
        } else {
          minutesRemaining = minutes;
        }
        seconds--;
        if (seconds <= 0) {
          minutesRemaining = '00';
          secondsToEnd = '00';
        }
        if (minutesRemaining >= 1) {
          this.lessThanMinuts = false;
          this.countDown = minutesRemaining + ':' + secondsToEnd;
        } else {
          this.lessThanMinuts = true;
          this.countDown = secondsToEnd;
        }
        this.cdRef.detectChanges();
      }, 1000);
    }
  }

  openHelp(level, index) {
    this.helpService.openHelp(level, index, 'INVEST');
  }

  getPayType(event) {
    this.getPayTypeEvent.emit(event);
  }

  getCodePromotion(event) {
    this.data.promCode = event;
    this.getCodePromotionEvent.emit(event);
  }

  startSign(event) {
    this.startSignEvent.emit(event);
  }

  getAmountValue(value) {
    this.amountValueEvent.emit(value);
  }

  purchase(event) {
    this.purchaseEvent.emit(event);
  }

  public setInvestId(id) {
    this.investId = id;
    this.cdRef.detectChanges();
  }

  goToSignDocuments() {
    this.previewDocuments = !this.previewDocuments;
    this.cdRef.detectChanges();
  }

  editInvest() {
    this.isTimeStop = false;
    this.step = 1;
    if (this.interval) {
      try {
        clearInterval(this.interval);
        this.interval = null;
      } catch {
        this.interval = null;
      }
    }
    this.localInvestProject = false;
    //this.changeHuspotStage();
    this.overviewService.getCancelInvest(this.investId).subscribe((x) => {
      this.cancelInvestEvent.emit();
      this.loaderInvestProcess = false;
      this.countdownStarted = false;
      this.countDown = '30:00';
      this.cdRef.detectChanges();
    }, error => {
      this.overviewService.rejectPreviousInvest(this.investId).subscribe(() => {
        this.loaderInvestProcess = false;
        this.countdownStarted = false;
        this.countDown = '30:00';
        this.cdRef.detectChanges();
      }, error => {
        this.loaderInvestProcess = false;
        this.countdownStarted = false;
        this.countDown = '30:00';
        this.cdRef.detectChanges();
      });
      this.cdRef.detectChanges();
    });
    this.cdRef.detectChanges();
  }

  getLocalInvestId(value) {
    this.localInvestId = value.id;
    this.headerData.profitability = value.prof;
    this.cdRef.detectChanges();
  }

  getPromotionalMoney(value) {
    this.promotionalModel = value;
    this.cdRef.detectChanges();
  }

  showTest() {
    this.step = 0;
    this.changeHuspotStage();
    this.cdRef.detectChanges();
  }

  closeAndCheckIban() {
    this.closeAndCheckIbanEvent.emit();
    this.cdRef.detectChanges();
  }

  getHasToBookInvestment(value) {
    this.hasToBookInvestment = value;
    if (value && !this.advisePercentShowed) {
      this.advisePercentShowed = true;
      this.percentInv = ((this.data.bodyInfo.reserved + this.data.bodyInfo.contributed + this.data.bodyInfo.preordered) / this.data.bodyInfo.total) * 100;
      if (this.percentInv > 100) {
        this.originalStep = this.step;
        this.step = 6;
      }
    }
    this.cdRef.detectChanges();
  }

  getUserValidatedInPriorityGroup(value) {
    this.userValidatedInPriorityGroup = value;
    this.cdRef.detectChanges();
  }

  bookInvestmentAction(index) {
    this.closeModal();
    this.cdRef.detectChanges();
  }

  continueWithMyReserve() {
    this.showOverfundedWarning = false;
    this.step = 1;
    this.cdRef.detectChanges();
  }

  continueFromOverfundedWarning() {
    this.showOverfundedWarning = false;
    this.step = this.originalStep;
    this.cdRef.detectChanges();
  }

  calculatePriorityGroupLogic() {
    const priorityGroups = this.data.bodyInfo.priority_groups;
    if (!priorityGroups || priorityGroups.length === 0) {
      return;
    }

    // Ordenar grupos por prioridad (menor número = mayor prioridad)
    const sortedGroups = priorityGroups.slice().sort((a, b) => a.priority - b.priority);

    // Encontrar el grupo del usuario con mayor prioridad que no esté lleno
    const userGroups = sortedGroups.filter((pg: any) => pg.isEnabledForUser);
    this.userPriorityGroup = userGroups.find((pg: any) => !pg.isGroupObjetiveFull) || null;
    this.priorityNumber = this.userPriorityGroup && this.userPriorityGroup.priority ? this.userPriorityGroup.priority : null;
    // Si todos los grupos del usuario están llenos, buscar el siguiente disponible
    if (!this.userPriorityGroup && userGroups.length > 0) {
      // Usuario tenía grupos pero todos están llenos
      const allUserGroupsFull = userGroups.every((pg: any) => pg.isGroupObjetiveFull);
      if (allUserGroupsFull) {
        // Buscar si hay otro grupo habilitado sin objetivo lleno
        this.userPriorityGroup = userGroups.find((pg: any) => !pg.isGroupObjetiveFull);
        if (!this.userPriorityGroup) {
          // No hay más grupos disponibles, mostrar reservas
          this.shouldShowReservation = true;
          this.originalStep = this.step;
          this.step = 6;
          this.advisePercentShowed = true;
          return;
        }
      }
    }

    if (!this.userPriorityGroup) {
      return;
    }

    // Calcular datos de inversión por grupo para la tabla
    let totalGroupsContributed = 0;
    const userGroupPriority = this.userPriorityGroup.priority;
    this.groupsInvestmentData = sortedGroups.map((pg: any) => {
      const contributed = pg.contributedAmount || 0;
      totalGroupsContributed += contributed;
      return {
        name: pg.name,
        priority: pg.priority,
        contributedAmount: contributed,
        investObjective: pg.investObjective,
        isUserGroup: pg.priority === userGroupPriority, // Solo marcar el grupo activo del usuario
        isEnabledForUser: pg.isEnabledForUser,
        isGroupObjetiveFull: pg.isGroupObjetiveFull
      };
    });

    // Calcular inversión de usuarios globales (sin grupo prioritario)
    this.globalUsersInvestment = this.data.bodyInfo.reserved;

    // Determinar lógica según si el grupo tiene investObjective o no
    if (this.userPriorityGroup.investObjective != null) {
      // Grupo CON investObjective
      this.userHasGroupWithObjective = true;
      const remaining = this.userPriorityGroup.investObjective - (this.userPriorityGroup.contributedAmount - this.globalUsersInvestment || 0);
      this.userGroupMaxInvestment = Math.max(0, remaining);

      // Si el objetivo del grupo está lleno
      if (this.userPriorityGroup.contributedAmount >= this.userPriorityGroup.investObjective) {
        // Buscar siguiente grupo sin objetivo lleno
        const nextGroup = userGroups.find((pg: any) =>
          pg.priority > this.userPriorityGroup.priority && !pg.isGroupObjetiveFull
        );
        if (!nextGroup) {
          // No hay más grupos, mostrar reservas
          this.shouldShowReservation = true;
          this.step = 6;
          this.advisePercentShowed = true;
          return;
        }
      }
    } else {
      // Grupo SIN investObjective - mostrar tabla y calcular máximo
      this.userHasGroupWithObjective = false;
      this.showGroupsTable = true;

      // Calcular máximo: suma de lo invertido por grupos menos prioritarios + usuarios globales
      const userPriority = this.userPriorityGroup.priority;
      this.maxFromLessPriorityGroups = 0;

      sortedGroups.forEach((pg: any) => {
        if (pg.priority > userPriority) {
          this.maxFromLessPriorityGroups += (pg.contributedAmount || 0);
        }
      });
      // Añadir inversión de usuarios globales
      this.maxFromLessPriorityGroups += this.globalUsersInvestment;

      // Verificar si hay grupos más prioritarios sin investObjective
      const morePriorityGroupsWithoutObjective = sortedGroups.some((pg: any) =>
        pg.priority < userPriority && pg.investObjective == null
      );

      if (morePriorityGroupsWithoutObjective) {
        this.showPriorityWarning = true;
      }

      this.userGroupMaxInvestment = this.maxFromLessPriorityGroups;
    }

    // Calculate current stage
    let currentStage = null;
    if (this.data.bodyInfo.investmentStages && this.data.bodyInfo.investmentStages.length > 0) {
      const now = new Date();
      for (let i = 0; i < this.data.bodyInfo.investmentStages.length; i++) {
        const stage = this.data.bodyInfo.investmentStages[i];
        const nextStage = this.data.bodyInfo.investmentStages[i + 1];
        const startDate = new Date(this.convertToIos(momentNs(stage.start_date).format('YYYY-MM-DD HH:mm:ss')));
        const nextStartDate = nextStage ? new Date(this.convertToIos(momentNs(nextStage.start_date).format('YYYY-MM-DD HH:mm:ss'))) : null;
        const isCurrentStage = (now >= startDate) && (!nextStage || now < nextStartDate);
        if (isCurrentStage) {
          currentStage = stage;
          break;
        }
      }
    }

    if (currentStage && currentStage.type === 2) {
      // Siempre mostrar step 6 con la tabla de grupos cuando hay priority groups
      this.showGroupsTable = true;
      this.originalStep = this.step;
      this.step = 6;
      this.advisePercentShowed = true;

      const isOverfunded = this.data.bodyInfo.contributed >= this.data.bodyInfo.total;
      if (isOverfunded) {
        this.showOverfundedWarning = true;
      }
    } else if (currentStage && currentStage.type === 1) {
      this.isPreorderStage = true;
    }
  }

  ngOnDestroy() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

}
